/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Record_PillInputs */

const en_us2_share_record_pill = /** @type {(inputs: Share_Record_PillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal record`)
};

const pt_br2_share_record_pill = /** @type {(inputs: Share_Record_PillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recorde pessoal`)
};

const es_419_share_record_pill = /** @type {(inputs: Share_Record_PillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Récord personal`)
};

const pt_pt2_share_record_pill = /** @type {(inputs: Share_Record_PillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recorde pessoal`)
};

const fr_fr2_share_record_pill = /** @type {(inputs: Share_Record_PillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Record personnel`)
};

const de_de2_share_record_pill = /** @type {(inputs: Share_Record_PillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Persönlicher Rekord`)
};

const it_it2_share_record_pill = /** @type {(inputs: Share_Record_PillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Record personale`)
};

/**
* | output |
* | --- |
* | "Personal record" |
*
* @param {Share_Record_PillInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const share_record_pill = /** @type {((inputs?: Share_Record_PillInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Record_PillInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_share_record_pill(inputs)
	if (locale === "es-419") return es_419_share_record_pill(inputs)
	if (locale === "pt-PT") return pt_pt2_share_record_pill(inputs)
	if (locale === "fr-FR") return fr_fr2_share_record_pill(inputs)
	if (locale === "de-DE") return de_de2_share_record_pill(inputs)
	if (locale === "it-IT") return it_it2_share_record_pill(inputs)
	return en_us2_share_record_pill(inputs)
});
export { share_record_pill as "share.record_pill" }